module.exports = __webpack_public_path__ + "static/media/placeholder_insights.f96dd261.png";